import {
  FaBroadcastTower,
  FaCheckCircle,
  FaFireExtinguisher,
  FaRegClock,
  FaShieldAlt,
  FaSlidersH,
} from 'react-icons/fa';
import { Link } from 'react-router-dom';
import Header from '../Header/Header.js';
import Footer from '../Footer/Footer.js';
import { streletsMonitoringService } from '../ServicesPage/servicesData.js';
import '../ServicesPage/ServicesPage.css';
import './StreletsMonitoringPage.css';

const connectionSteps = [
  {
    title: 'Аудит и подготовка',
    text:
      'Проверяем действующую пожарную автоматику, схему объекта и готовность оборудования к подключению.',
    icon: <FaShieldAlt />,
  },
  {
    title: 'Монтаж и настройка',
    text:
      'Устанавливаем объектовое оборудование, настраиваем каналы связи и тестируем передачу извещений.',
    icon: <FaSlidersH />,
  },
  {
    title: 'Контроль и сопровождение',
    text:
      'Передаем систему в эксплуатацию, сопровождаем обслуживание и следим за стабильной работой решения.',
    icon: <FaBroadcastTower />,
  },
];

const targetObjects = [
  'Школы, детские сады и образовательные учреждения',
  'Торговые центры, гостиницы и бизнес-центры',
  'Медицинские учреждения и объекты с круглосуточным пребыванием людей',
  'Административные и общественные здания с повышенными требованиями к реагированию',
];

const accentFacts = [
  {
    value: '24/7',
    label: 'непрерывная готовность к передаче сигнала',
    icon: <FaRegClock />,
  },
  {
    value: 'Без звонка',
    label: 'автоматическая отправка тревожного извещения',
    icon: <FaFireExtinguisher />,
  },
  {
    value: 'Под ключ',
    label: 'от обследования объекта до обслуживания системы',
    icon: <FaCheckCircle />,
  },
];

function StreletsMonitoringPage() {
  return (
    <>
      <Header />
      <main className="content">
        <section className="streletsPage">
          <section className="streletsPage__hero">
            <div className="streletsPage__hero-content">
              <h2 className="streletsPage__title">
                {streletsMonitoringService.title}
              </h2>
              <p className="streletsPage__lead">
                {streletsMonitoringService.lead}
              </p>
              <div className="streletsPage__hero-actions">
                <Link
                  to="/strelets-monitoring/appeals/"
                  className="streletsPage__hero-button streletsPage__hero-button_primary"
                >
                  Подать уведомление*
                </Link>
                <Link
                  to="/strelets-monitoring/request/"
                  className="streletsPage__hero-button streletsPage__hero-button_secondary"
                >
                  Заключить договор
                </Link>
              </div>
              <p className="streletsPage__hero-note">
                * В рамках постановления Правительства Самарской области от 07.05.2026 № 297
                «О внесении изменения в постановление Правительства Самарской области
                от 29.11.2024 № 843 “Об утверждении Порядка организации дублирования
                сигналов о возникновении пожара в подразделения пожарной охраны
                на территории Самарской области”».
              </p>
            </div>

            <div className="streletsPage__hero-panel">
              <p className="streletsPage__panel-title">
                Что важно для объекта
              </p>
              <ul className="streletsPage__hero-points">
                {streletsMonitoringService.cardPoints.map((point) => (
                  <li className="streletsPage__hero-point" key={point}>
                    <FaCheckCircle className="streletsPage__hero-point-icon" />
                    <span>{point}</span>
                  </li>
                ))}
              </ul>
            </div>
          </section>

          <section className="streletsPage__facts">
            {accentFacts.map((fact) => (
              <article className="streletsPage__fact" key={fact.label}>
                <div className="streletsPage__fact-icon">{fact.icon}</div>
                <p className="streletsPage__fact-value">{fact.value}</p>
                <p className="streletsPage__fact-label">{fact.label}</p>
              </article>
            ))}
          </section>

          <section className="streletsPage__section">
            <div className="streletsPage__section-heading">
              <p className="streletsPage__section-kicker">Как это работает</p>
              <h3 className="streletsPage__section-title">
                Подключаем объект без шаблонной схемы
              </h3>
              <p className="streletsPage__section-text">
                Решение подбирается под действующую пожарную сигнализацию,
                каналы связи и режим эксплуатации конкретного объекта, поэтому
                мы начинаем не с оборудования, а с обследования и сценария
                передачи сигнала.
              </p>
            </div>
            <div className="streletsPage__steps">
              {connectionSteps.map((step) => (
                <article className="streletsPage__step" key={step.title}>
                  <div className="streletsPage__step-icon">{step.icon}</div>
                  <h4 className="streletsPage__step-title">{step.title}</h4>
                  <p className="streletsPage__step-text">{step.text}</p>
                </article>
              ))}
            </div>
          </section>

          <section className="streletsPage__section streletsPage__section_split">
            <article className="streletsPage__story">
              <p className="streletsPage__section-kicker">Зачем подключать</p>
              <h3 className="streletsPage__section-title">
                Меньше зависимости от человеческого фактора
              </h3>
              <div className="streletsPage__story-text">
                {streletsMonitoringService.productText.map((paragraph) => (
                  <p key={paragraph}>{paragraph}</p>
                ))}
              </div>
            </article>

            <article className="streletsPage__result-card">
              <p className="streletsPage__panel-title">Практический эффект</p>
              <ul className="streletsPage__result-list">
                {streletsMonitoringService.resultList.map((item) => (
                  <li className="streletsPage__result-item" key={item}>
                    <FaCheckCircle className="streletsPage__result-icon" />
                    <span>{item}</span>
                  </li>
                ))}
              </ul>
            </article>
          </section>

          <section className="streletsPage__section streletsPage__section_split">
            <article className="streletsPage__works-card">
              <p className="streletsPage__section-kicker">Что делаем</p>
              <h3 className="streletsPage__section-title">
                Полный цикл работ по подключению
              </h3>
              <ul className="streletsPage__works-list">
                {streletsMonitoringService.includedWorks.map((item) => (
                  <li className="streletsPage__works-item" key={item}>
                    <FaCheckCircle className="streletsPage__works-icon" />
                    <span>{item}</span>
                  </li>
                ))}
              </ul>
            </article>

            <article className="streletsPage__objects-card">
              <p className="streletsPage__section-kicker">Для каких объектов</p>
              <h3 className="streletsPage__section-title">
                Там, где важна скорость передачи тревоги
              </h3>
              <div className="streletsPage__objects-grid">
                {targetObjects.map((item) => (
                  <div className="streletsPage__object" key={item}>
                    {item}
                  </div>
                ))}
              </div>
            </article>
          </section>

          <section className="streletsPage__section">
            <div className="streletsPage__section-heading">
              <p className="streletsPage__section-kicker">Фотографии</p>
              <h3 className="streletsPage__section-title">
                Оборудование и варианты размещения
              </h3>
            </div>
            <div className="streletsPage__gallery">
              {streletsMonitoringService.gallery.map((image) => (
                <figure className="streletsPage__gallery-item" key={image.src}>
                  <img
                    src={image.src}
                    alt={image.alt}
                    className="streletsPage__gallery-image"
                  />
                </figure>
              ))}
            </div>
          </section>

          {/* ServiceRequestForm temporarily disabled on Strelets-Monitoring page. */}
        </section>
      </main>
      <Footer />
    </>
  );
}

export default StreletsMonitoringPage;
